export const Team = {
    RED: 'red',
    BLUE: 'blue'
};

export const defaultSettings = {
    targetScore: 21,
    winBy: 2,
    maxScore: 23,
    redTeamName: 'Red',
    blueTeamName: 'Blue'
};

export function clampSettings(settings) {
    return {
        ...settings,
        targetScore: Math.max(1, settings.targetScore),
        winBy: Math.max(1, settings.winBy),
        maxScore: Math.max(settings.targetScore, settings.maxScore)
    };
}

export function loadSettings(storage = localStorage) {
    const stored = storage.getItem('AuroraVolleyQuest.GameSettings');
    if (stored) {
        try {
            const settings = JSON.parse(stored);
            return clampSettings(settings);
        } catch (e) {
            return defaultSettings;
        }
    }
    return defaultSettings;
}

export function saveSettings(settings, storage = localStorage) {
    storage.setItem('AuroraVolleyQuest.GameSettings', JSON.stringify(settings));
}

export function isWinningScore(team, redScore, blueScore, settings) {
    const score = team === Team.RED ? redScore : blueScore;
    const otherScore = team === Team.RED ? blueScore : redScore;
    const lead = score - otherScore;

    if (score >= settings.targetScore && lead >= settings.winBy) {
        return true;
    }

    if (score === settings.maxScore && otherScore < settings.maxScore) {
        return true;
    }

    return false;
}

export function getWinner(redScore, blueScore, settings) {
    if (isWinningScore(Team.RED, redScore, blueScore, settings)) {
        return Team.RED;
    }
    if (isWinningScore(Team.BLUE, redScore, blueScore, settings)) {
        return Team.BLUE;
    }
    return null;
}
